import { render } from "./designWrapper.vue?vue&type=template&id=54caf7b2&scoped=true"
import script from "./designWrapper.vue?vue&type=script&lang=js"
export * from "./designWrapper.vue?vue&type=script&lang=js"

import "./designWrapper.vue?vue&type=style&index=0&id=54caf7b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54caf7b2"]])

export default __exports__